import React, { useEffect, useState } from 'react';
import { StyleSheet, View, Text, FlatList, TouchableOpacity, ScrollView } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import { AnimatedFAB } from 'react-native-paper';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import theme from './../../lib/theme.js';
import { apiFetch } from '../modules/api';

const ListadoUPCS = () => {

  const navigation = useNavigation();
  const [upcs, setUpcs] = useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  async function fetchData() {
    setIsLoading(true);
    const datos = '{"empresa" : "' + gEmpresa + '","operador" : "' + gOperador + '","determinante" : "' + gDeterminante + '"}'

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos
    }

    const response = await apiFetch(gApiPath + "/api/upcs", requestOptions);
    const json = await response.json();

    setUpcs(json.datos);
    global.upcs = json.datos;
    setIsLoading(false);
    // console.log(json.datos);

    // json.datos.forEach(upcs => {
    //   console.log(upcs.descripcion);
    /*for (let key in upc) {
        console.log(`${key}: ${upc[key]}`);
    }*/
    // });


    //console.log(json.datos);

  }


  useEffect(function () {
    gPantalla = "";
    let mounted = true;
    setUpcs({});
    navigation.addListener('focus', () => {
      if (mounted) {
        fetchData();
      }
      return () => mounted = false;
    });

  }, []);

  const getDeterminanteDetalle = (data, opc) => {
    const text = data.split("-");
    if (opc === 1) {
      if (text.length > 0) {
        return text[0].trim();
      }
    }
    if (opc === 2) {
      if (text.length > 1) {
        return text[1].trim();
      }
    }
    return "";
  }

  return (
    <View style={styles.container}>
      <Fondo />
        <View style={{ maxHeight: 130, minWidth: 320, width: "100%", height: "120px" }} >
          <View
            style={{
              ...theme.cards, backgroundColor: "#fff",
              flexWrap: 'wrap', flex: 1, height: 110, maxHeight: 130, justifyContent: "center"
            }}>
            <View style={{ alignItems: 'center', justifyContent: "center", height: "100%", marginRight: 10 }}>
              <MaterialCommunityIcons style={{ textAlign: 'center', marginTop: -10 }} name="store" size={50} color="#333" />
            </View>
            <View style={{ whiteSpace: "nowrap", maxWidth: 300 }}>
              <Text style={{ ...theme.subTitle, fontWeight: 'bold' }} ellipsizeMode="tail" numberOfLines={2}>{gOperador.toUpperCase() + " - " + gDeterminante.toUpperCase()}</Text>
              <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{getDeterminanteDetalle(gDeterminanteDetalle, 1)}{ }</Text>
              <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{getDeterminanteDetalle(gDeterminanteDetalle, 2)}{ }</Text>
            </View>
          </View>
        </View>
            {!isLoading ? (
              <FlatList
                data={upcs}
                style={{ flex: 1, width: '100%', maxHeight: "75vh" }}
                renderItem={({ item }) => (
                  item.inv_exhibido_null > 0 && item.inv_bodega_null > 0 && item.hay_foto_upc === 'no' ?

                    <TouchableOpacity style={{ ...theme.cards, backgroundColor: theme.colors.danger }} onPress={() => irMenuUpc(navigation, item.upc, item.inv_teorico, (item.inv_exhibido_null === 0 ? item.inv_exhibido : ""), (item.inv_bodega_null === 0 ? item.inv_bodega : ""), item.descripcion, item.comentarios)}  >
                      {item.estatus_upc === '2' ? <Text style={styles.text2} >Venta Cero</Text> : null}
                      {item.estatus_upc === '3' ? <Text style={styles.text2} >Agotado</Text> : null}
                      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                        <Text style={{ ...theme.storeCardTitle, fontSize: 25 }} >{item.upc}</Text>
                      </View>
                      <Text style={{...theme.storeCardTitle, marginBottom: "5%"}} ellipsizeMode="tail" numberOfLines={3}>{item.descripcion} </Text>

                      <View style={{ flexWrap: 'wrap', flex: 1, height: "50%", justifyContent: "center", alignItems: 'center' }}>
                        <View style={{ alignItems: 'center', height: "50%", justifyContent: "center", marginRight: 10, width: "40%" }}>
                          <Text style={theme.storeCardTitle} >Inventario</Text>
                        </View>
                        <View style={{ whiteSpace: "nowrap", width: "60%" }}>
                          <Text style={theme.storeCardTitleSmall} >{'Teórico: '} <Text style={{ fontWeight: 'bold' }}>{item.inv_teorico}</Text></Text>
                          <Text style={theme.storeCardTitleSmall} >{"Exhibido: "} <Text style={{ fontWeight: 'bold' }}>{(item.inv_exhibido_null === 0 ? item.inv_exhibido : "N/C")}</Text></Text>
                          <Text style={theme.storeCardTitleSmall} >{"Bodega: "} <Text style={{ fontWeight: 'bold' }}>{(item.inv_bodega_null === 0 ? item.inv_bodega : "N/C")}</Text></Text>
                          <Text style={theme.storeCardTitleSmall} >Foto registrada: <Text style={{ fontWeight: 'bold' }}>no</Text></Text>
                        </View>
                      </View>
                    </TouchableOpacity>

                    : (item.inv_exhibido_null === 0 && item.inv_bodega_null > 0 && item.hay_foto_upc === 'no') ||
                      (item.inv_exhibido_null === 0 && item.inv_bodega_null > 0 && item.hay_foto_upc === 'si') ||
                      (item.inv_exhibido_null === 0 && item.inv_bodega_null === 0 && item.hay_foto_upc === 'no') ||
                      (item.inv_exhibido_null > 0 && item.inv_bodega_null === 0 && item.hay_foto_upc === 'no') ||
                      (item.inv_exhibido_null > 0 && item.inv_bodega_null === 0 && item.hay_foto_upc === 'si') ||
                      (item.inv_exhibido_null > 0 && item.inv_bodega_null > 0 && item.hay_foto_upc === 'si') ?

                      <TouchableOpacity style={{ ...theme.cards, backgroundColor: theme.colors.warning }} onPress={() => irMenuUpc(navigation, item.upc, item.inv_teorico, (item.inv_exhibido_null === 0 ? item.inv_exhibido : ""), (item.inv_bodega_null === 0 ? item.inv_bodega : ""), item.descripcion, item.comentarios)} >
                        {item.estatus_upc === '2' ? <Text style={styles.text2} >Venta Cero</Text> : null}
                        {item.estatus_upc === '3' ? <Text style={styles.text2} >Agotado</Text> : null}
                        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                          <Text style={{ ...theme.storeCardTitle, fontSize: 25 }} >{item.upc}</Text>
                        </View>
                        <Text style={{...theme.storeCardTitle, marginBottom: "5%"}} ellipsizeMode="tail" numberOfLines={3}>{item.descripcion} </Text>
                        <View style={{ flexWrap: 'wrap', flex: 1, height: "50%", justifyContent: "center", alignItems: 'center' }}>
                          <View style={{ alignItems: 'center', height: "50%", justifyContent: "center", marginRight: 10, width: "40%" }}>
                            <Text style={theme.storeCardTitle} >Inventario</Text>
                          </View>
                          <View style={{ whiteSpace: "nowrap", width: "60%" }}>
                            <Text style={theme.storeCardTitleSmall} >{'Teórico: '} <Text style={{ fontWeight: 'bold' }}>{item.inv_teorico}</Text></Text>
                            <Text style={theme.storeCardTitleSmall} >{"Exhibido: "} <Text style={{ fontWeight: 'bold' }}>{(item.inv_exhibido_null === 0 ? item.inv_exhibido : "N/C")}</Text></Text>
                            <Text style={theme.storeCardTitleSmall} >{"Bodega: "} <Text style={{ fontWeight: 'bold' }}>{(item.inv_bodega_null === 0 ? item.inv_bodega : "N/C")}</Text></Text>
                            <Text style={theme.storeCardTitleSmall} >Foto registrada: <Text style={{ fontWeight: 'bold' }}>{item.hay_foto_upc}</Text></Text>
                          </View>
                        </View>
                      </TouchableOpacity>

                      :
                      <TouchableOpacity style={{ ...theme.cards, backgroundColor: theme.colors.success }} onPress={() => irMenuUpc(navigation, item.upc, item.inv_teorico, (item.inv_exhibido_null === 0 ? item.inv_exhibido : ""), (item.inv_bodega_null === 0 ? item.inv_bodega : ""), item.descripcion, item.comentarios)} >
                        {item.estatus_upc === '2' ? <Text style={styles.text2} >Venta Cero</Text> : null}
                        {item.estatus_upc === '3' ? <Text style={styles.text2} >Agotado</Text> : null}
                        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                          <Text style={{ ...theme.storeCardTitle, fontSize: 25 }} >{item.upc}</Text>
                        </View>
                        <Text style={{...theme.storeCardTitle, marginBottom: "5%"}} ellipsizeMode="tail" numberOfLines={3}>{item.descripcion} </Text>
                        <View style={{ flexWrap: 'wrap', flex: 1, height: "50%", justifyContent: "center", alignItems: 'center' }}>
                          <View style={{ alignItems: 'center', height: "50%", justifyContent: "center", marginRight: 10, width: "40%" }}>
                            <Text style={theme.storeCardTitle} >Inventario</Text>
                          </View>
                          <View style={{ whiteSpace: "nowrap", width: "60%" }}>
                            <Text style={theme.storeCardTitleSmall} >{'Teórico: '} <Text style={{ fontWeight: 'bold' }}>{item.inv_teorico}</Text></Text>
                            <Text style={theme.storeCardTitleSmall} >{"Exhibido: "} <Text style={{ fontWeight: 'bold' }}>{(item.inv_exhibido_null === 0 ? item.inv_exhibido : "N/C")}</Text></Text>
                            <Text style={theme.storeCardTitleSmall} >{"Bodega: "} <Text style={{ fontWeight: 'bold' }}>{(item.inv_bodega_null === 0 ? item.inv_bodega : "N/C")}</Text></Text>
                            <Text style={theme.storeCardTitleSmall} >Foto registrada: <Text style={{ fontWeight: 'bold' }}>si</Text></Text>
                          </View>
                        </View>
                      </TouchableOpacity>
                )}
                keyExtractor={item => item.id}
              />

            ) : (
              <View>
                <Text>Cargando...</Text>
              </View>
            )}
        <AnimatedFAB
          icon={'barcode-scan'}
          label={'Escanear código'}
          extended={false}
          onPress={() => irScanner(navigation)}
          animateFrom={'right'}
          iconMode={'static'}
          style={theme.floatingButton}
          visible={!isLoading}
        />
      </View>
  );
}

export default ListadoUPCS


function irMenuUpc(navigation, upc, invT, invE, invB, descripcionUpc, comentarios) {

  gUpc = upc;
  gInvt = invT;
  gInve = invE;
  gInvb = invB;
  gComentarios = comentarios;
  gDescripcionUpc = descripcionUpc;
  if (global.gTipoCapInv == true) {

    global.gLotescapturados = {
      HeadTable1: ['Inventarios capturados'],
      HeadTable2: ['Lote', 'Caducidad', 'Exhibido', 'Bodega', 'Total'],
      DataTable1: [

        ['', '', '', '', ''],
        ['', '', '', '', '']

      ]

    }
    global.gLote = "";
    navigation.navigate('UPCLote');

  } else {

    navigation.navigate('UPC');

  }


}

function irScanner(navigation) {

  navigation.navigate('ScannerUpc');

}


const styles = StyleSheet.create({
  container: {
    backgroundColor: '#f1f1f1',
    alignItems: 'center',
  },
  text: {
    fontSize: 15,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    alignItems: 'center',
    justifyContent: 'center'

  },
  upc: {
    fontSize: 25,
    color: 'white',
    borderRadius: 30,
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  titulo: {
    fontSize: 20,
    color: "black",
    fontWeight: 'bold',
    marginTop: 5,
    marginBottom: 10,
    alignItems: 'center',
    justifyContent: 'center'
  },

  titulo1: {
    fontSize: 50,
    color: "white",
    fontWeight: 'bold',
    marginTop: 10,
  },

  titulo2: {
    fontSize: 35,
    color: "white",
    fontWeight: 'bold',
    padding: 10,
    marginTop: 40,
  },

  subTitle: {
    fontSize: 20,
    color: 'black',
  },

  button: {

    padding: 10,
    width: '100%',
    height: 180,
    marginTop: 5,
    borderRadius: 2,
    borderWidth: 10,
    borderColor: '#ddd',
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center'

  },

  button2: {

    padding: 10,
    width: '100%',
    height: '10%',
    marginTop: 5,
    borderRadius: 2,
    borderWidth: 10,
    borderColor: 'white',
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center'

  },
  container2: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',

  },
  text2: {
    width: '100%',
    fontSize: 20,
    backgroundColor: theme.colors.warning,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontWeight: 'bold',
    color: 'white',
    borderRadius: 10,
    textShadowColor: 'rgba(0, 0, 0, 0.1)',
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 1
  }

});



